import React from 'react';
import { Container } from 'react-bootstrap';

const steps = [
  {
    num: 1,
    title: 'Find the leverage',
    desc: 'We start with a direct conversation about the operation, the bottlenecks, the team, and the places where manual work is already costing money.'
  },
  {
    num: 2,
    title: 'Map the real workflows',
    desc: 'We document how work actually moves through the business today, including the spreadsheets, inboxes, tribal knowledge, and system gaps.'
  },
  {
    num: 3,
    title: 'Prioritize ROI first',
    desc: 'You get a practical roadmap that separates nice-to-have technology from the automation and ecommerce work most likely to produce measurable return.'
  },
  {
    num: 4,
    title: 'Build inside your environment',
    desc: 'We implement AI systems, marketplace workflows, integrations, and reporting around the tools and people already running the business.'
  },
  {
    num: 5,
    title: 'Train the team',
    desc: 'Your people learn the new operating model as it is being built, with SOPs, usage habits, and confidence developed before handoff.'
  },
  {
    num: 6,
    title: 'Optimize after launch',
    desc: 'We stay close after systems go live, tune what is working, remove friction, and expand only when the operation is ready for the next layer.'
  }
];

const OpenClawSection = () => {
  return (
    <section className="wn-openclaw" id="process">
      <Container>
        <div className="text-center wn-fade-in">
          <div
            className="wn-section-label"
            style={{ justifyContent: 'center' }}
          >
            <span className="label-dot" />
            How It Works
          </div>
          <h2 className="wn-section-title centered">
            Diagnose first. Build in the business. Leave systems your team can
            run.
          </h2>
          <p className="wn-section-subtitle centered">
            No mystery, no lock-in. We work like operators because adoption is
            where most AI and ecommerce projects win or die.
          </p>
        </div>

        <div className="wn-process-grid">
          {steps.map((step, i) => (
            <div
              key={i}
              className={`wn-process-step wn-fade-in wn-fade-in-delay-${
                (i % 3) + 1
              }`}
            >
              <div className="step-number">{step.num}</div>
              <h4>{step.title}</h4>
              <p>{step.desc}</p>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default OpenClawSection;
